export default {
  'userandlogin.login.userName': '用户名',
  'userandlogin.login.password': '密码',
  'userandlogin.login.message-invalid-credentials': '账户或密码错误（admin/ant.design）',
  'userandlogin.login.message-invalid-verification-code': '验证码错误',
  'userandlogin.login.tab-login-credentials': '账户密码登录',
  'userandlogin.login.tab-login-mobile': '手机号登录',
  'userandlogin.login.remember-me': '自动登录',
  'userandlogin.login.forgot-password': '忘记密码',
  'userandlogin.login.sign-in-with': '其他登录方式',
  'userandlogin.login.signup': '注册账户',
  'userandlogin.login.login': '登录',
  'userandlogin.register.register': '注册',
  'userandlogin.register.get-verification-code': '获取验证码',
  'userandlogin.register.sign-in': '使用已有账户登录',
  'userandlogin.register-result.msg': '你的账户：{email} 注册成功',
  'userandlogin.register-result.activation-email':
    '激活邮件已发送到你的邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户。',
  'userandlogin.register-result.back-home': '返回首页',
  'userandlogin.register-result.view-mailbox': '查看邮箱',
  'userandlogin.email.required': '请输入邮箱地址！',
  'userandlogin.email.wrong-format': '邮箱地址格式错误！',
  'userandlogin.userName.required': '请输入用户名!',
  'userandlogin.password.required': '请输入密码！',
  'userandlogin.password.twice': '两次输入的密码不匹配!',
  'userandlogin.strength.msg': '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'userandlogin.strength.strong': '强度：强',
  'userandlogin.strength.medium': '强度：中',
  'userandlogin.strength.short': '强度：太短',
  'userandlogin.confirm-password.required': '请确认密码！',
  'userandlogin.phone-number.required': '请输入手机号！',
  'userandlogin.phone-number.wrong-format': '手机号格式错误！',
  'userandlogin.verification-code.required': '请输入验证码！',
  'userandlogin.title.required': '请输入标题',
  'userandlogin.date.required': '请选择起止日期',
  'userandlogin.goal.required': '请输入目标描述',
  'userandlogin.standard.required': '请输入衡量标准',
  'userandlogin.form.get-captcha': '获取验证码',
  'userandlogin.captcha.second': '秒',
  'userandlogin.form.optional': '（选填）',
  'userandlogin.form.submit': '提交',
  'userandlogin.form.save': '保存',
  'userandlogin.email.placeholder': '邮箱',
  'userandlogin.password.placeholder': '至少6位密码，区分大小写',
  'userandlogin.confirm-password.placeholder': '确认密码',
  'userandlogin.phone-number.placeholder': '手机号',
  'userandlogin.verification-code.placeholder': '验证码',
  'userandlogin.title.label': '标题',
  'userandlogin.title.placeholder': '给目标起个名字',
  'userandlogin.date.label': '起止日期',
  'userandlogin.placeholder.start': '开始日期',
  'userandlogin.placeholder.end': '结束日期',
  'userandlogin.goal.label': '目标描述',
  'userandlogin.goal.placeholder': '请输入你的阶段性工作目标',
  'userandlogin.standard.label': '衡量标准',
  'userandlogin.standard.placeholder': '请输入衡量标准',
  'userandlogin.client.label': '客户',
  'userandlogin.label.tooltip': '目标的服务对象',
  'userandlogin.client.placeholder': '请描述你服务的客户，内部客户直接 @姓名／工号',
  'userandlogin.invites.label': '邀评人',
  'userandlogin.invites.placeholder': '请直接 @姓名／工号，最多可邀请 5 人',
  'userandlogin.weight.label': '权重',
  'userandlogin.weight.placeholder': '请输入',
  'userandlogin.public.label': '目标公开',
  'userandlogin.label.help': '客户、邀评人默认被分享',
  'userandlogin.radio.public': '公开',
  'userandlogin.radio.partially-public': '部分公开',
  'userandlogin.radio.private': '不公开',
  'userandlogin.publicUsers.placeholder': '公开给',
  'userandlogin.option.A': '同事甲',
  'userandlogin.option.B': '同事乙',
  'userandlogin.option.C': '同事丙',
  'userandlogin.navBar.lang': '语言',
};
